import { StyleSheet } from "react-native"
import { baseColors } from "@Constants/baseStyles"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    }
})

export default styles
